import { useState, useEffect, useCallback } from 'react';
import type { IMediaLibraryImageModel } from '@/shared/models/media-library/media-library-image.model';

const MAX_SELECTION = 4;

export const useImageSelection = (imageData: IMediaLibraryImageModel[] | undefined) => {
  const [selected, setSelected] = useState<IMediaLibraryImageModel[]>([]);

  useEffect(() => {
    if (imageData && imageData.length > 0) {
      setSelected(imageData.slice(0, MAX_SELECTION));
    } else {
      setSelected([]);
    }
  }, [imageData]);

  const toggleSelect = useCallback((image: IMediaLibraryImageModel) => {
    setSelected((prev) => {
      const already = prev.find((img) => img.preSignedUrl === image.preSignedUrl);
      if (already) {
        return prev.filter((img) => img.preSignedUrl !== image.preSignedUrl);
      } else if (prev.length < MAX_SELECTION) {
        return [...prev, image];
      }
      return prev;
    });
  }, []);

  const isSelected = useCallback(
    (image: IMediaLibraryImageModel) => !!selected.find((img) => img.preSignedUrl === image.preSignedUrl),
    [selected]
  );

  const clearSelection = useCallback(() => {
    setSelected([]);
  }, []);

  return {
    selected,
    toggleSelect,
    isSelected,
    clearSelection,
    maxSelection: MAX_SELECTION,
  };
};
